import styled from 'styled-components';

export const Title = styled.h1`
  font-family: europa, sans-serif;
  font-weight: 700;
  font-size: 3.22vw; //62px
  line-height: 3.33vw; //64px
  margin-bottom: 1vw; //80px
  color: #F9F8F6;
`;